export const dateFormat = 'DD/MM/YYYY';
export const dateTimeFormat = 'DD/MM/YYYY HH:mm';
export const timeFormat = 'hh:mm';
export const time24hrFormat = 'HH:mm';
export const monthYearFormat = 'MM/YYYY';
export const emptyDateFormat = '--/--/--';
export const emptyTimeFormat = '--:--';
export const ISOStringFormat = 'YYYY-MM-DDT00:00:00';
export const dateFormatUS = 'MM/DD/YYYY';


export const convertUTCtoLocal = (momentDate: moment.Moment) => {
    var date = new Date(
      Date.UTC(
        momentDate.year(),
        momentDate.month(),
        momentDate.date(),
        momentDate.hours(),
        momentDate.minutes(),
        momentDate.seconds(),
      ),
    );
    return date;
  };